import {CrudRepository} from ".";
import Keycloak from "keycloak-js";
import axios from "redaxios";
import {HelpFile} from "../model";
import {isEmpty} from "../utils/control/isEmpty";

export class HelpFileRepository extends CrudRepository<HelpFile> {
    constructor(keycloak: Keycloak | null = null) {
        super('help_files', "POST", keycloak)
    }

    protected jsonToEntity(json: any): HelpFile | null {
        if (!json) return null;
        return {
            id: json.id,
            createdAt: json.createdAt,
            updatedAt: json.updatedAt,
            deletedAt: json.deletedAt,
            name: json.name,
            description: json.description,
            permission: json.permission,
            helpFile: json.helpFile,
            helpFileName: json.helpFileName,
            helpUrl: json.helpUrl,
            thumbnailFile: json.thumbnailFile,
            thumbnailFileName: json.thumbnailFileName,
            version: json.version,
            directory: json.directory,
            type: json.type
        }
    }

    public showTemplateFiles(fields ?: string) : Promise<HelpFile[] | null> {
        return new Promise<HelpFile[] | null>((resolve, reject) => {
            axios({
                url:`${process.env.REACT_APP_SERVER_URL}/show_template_files`,
                method: 'GET',
                headers: this.headers
            })
                .then((response : any) => {
                    resolve(this.jsonToEntities(response.data['hydra:member']));
                })
                .catch((error : any) => {
                    reject(error);
                })
        })
    }

    protected async entityToJson(entity: HelpFile): Promise<any> {
        const formData = new FormData();

        const exclude = ['helpFile', 'thumbnailFile']

        if (!isEmpty(entity.helpFile)) {
            const blob = new Blob([entity.helpFile], {type: entity.helpFile.type });
            const filename = entity.helpFile.name && entity.helpFile.name.split('\\').pop();
            formData.append('helpFile', blob, filename);
        }

        if (!isEmpty(entity.thumbnailFile)) {
            const blob = new Blob([entity.thumbnailFile], {type: entity.thumbnailFile.type });
            const filename = entity.thumbnailFile.name && entity.thumbnailFile.name.split('\\').pop();
            formData.append('thumbnailFile', blob, filename);
        }

        Object.keys(entity).forEach((key) => {
            if (!exclude.includes(key))
            {
                const value = entity.hasOwnProperty(key) ? (entity as any)[key] : undefined;
                if (value !== undefined && value !== null) {
                    switch (key) {
                        case 'directory':
                            formData.append(key, this.getIRI((entity as any)[key], 'help_directories'))
                            break;
                        default:
                            formData.append(key, (entity as any)[key])
                            break;
                    }
                }
            }
        })

        return formData;
    }
}